//Component Object
Component({
  properties: {
    cardData: {
      type: Object,
      value: {},
      observer: function (newVal) {
        if (newVal) {
          const { messages } = newVal;
          if (messages) {
            this.setData({
              displayMessages: messages.join("\n"),
            });
          }
        }
      },
    },
  },
  data: {
    displayMessages: "",
  },
  methods: {
    isUrlValid: function (url) {
      return url.indexOf("http://") === 0 || url.indexOf("https://") === 0;
    },
    /**
     * 跳转卡片页面
     */
    doJump: function () {
      const { expireDate, xcx = "", h5 } = this.data.cardData;
      if (expireDate && new Date() > new Date(Number(expireDate))) {
        wx.showToast({
          title: "该卡片已过期",
          icon: "none",
          duration: 2000,
        });
        return;
      }
      const url = h5;
      if (xcx) {
        const xcxUrl = xcx.replace("xcx://xcx", "");
        wx.navigateTo({
          url: xcxUrl,
        });
      } else if (url && this.isUrlValid(url)) {
        wx.navigateTo({
          url: `/pages/bridge/webview/index?url=${encodeURIComponent(url)}`,
        });
      } else {
        wx.showToast({
          title: "暂不支持的功能",
          icon: "none",
          duration: 2000,
        });
      }
    },
  },
  created: function () {},
  attached: function () {},
  ready: function () {},
  moved: function () {},
  detached: function () {},
});
